import { createContext } from 'react';
import type { MessagingContextValue } from './types';

export const MessagingContext = createContext<MessagingContextValue | null>(
  null
);
